export const CHAT_VISIBILITY_KEY = 'chat.visibility';
export const SEAMLY_ENVIRONMENT_CONFIG_KEY = 'seamly.environment.config';
export const CONVERSATION_SESSION_DETAILS_KEY = 'conversation.session.details';

export interface SeamlyEnvironmentConfig {
    seamlyEnvironment: string;
    seamlyApiDomain: string;
}

export interface ConversationSessionDetails {
    conversationLink: string;
    accessToken: string;
}
